import Model, { obj_with_default } from '/lib/model'
import currencies, { base_currencies } from '/lib/currencies'
import { formatMoney }  from 'accounting'
import humanize         from 'underscore.string/humanize'
import compact          from 'underscore-es/compact'
import { stripZone }    from '/lib/datetime'

export default \
class Ticket extends Model
  @className: 'Ticket'

  @belongsTo 'listing', model: 'Listing'
  @belongsTo 'event',   model: 'Event'
  @belongsTo 'user',    model: 'User'

  @hasMany 'cost_items',    model: 'CostItem'
  @hasMany 'installments',  model: 'Installment'
  @hasMany 'host_fields',   model: 'HostField'

  @computed 'formattedPrice', ->
    return 'Free' unless @price
    formatMoney @price, symbol: currencies[@base_currency].replace @base_currency, ''

  @computed 'url', ->
    "#{process.env.MULTIVERSE}/tickets/#{@id}"

  @computed 'startTime', ->
    stripZone @start_time

  @computed 'endTime', ->
    stripZone @end_time

  @computed 'createdAt', ->
    stripZone @created_at

  @computed 'transitions', ->
    return {} if @disputed

    # collect all possible state transitions
    actions = state_actions
    if @using_payment_plan
      actions[@state] = [actions[@state]..., payment_plan_actions[@state]...]

    ret = {}
    for tr in actions[@state] or []
      ret[tr] = transition_name_overrides?[tr] or humanize tr
    ret

  @computed 'confirmations', ->
    ret = {}
    for tr in state_actions[@state] or []
      switch typeof transition_confirmations[tr]
        when 'function'
          ret[tr] = transition_confirmations[tr](this)
          delete ret[tr] unless ret[tr]?
        when 'string'
          ret[tr] = transition_confirmations[tr]
    ret

  @computed 'disputed', ->
    @has_open_dispute

  @computed 'state_description', ->
    switch @state
      when 'failed', 'declined', 'error' # only used / populated for failed tickets atm
        compact([
          compact([
            @payment_decline_type
            @payment_decline_code
          ]).join(': ')
          @payment_decline_message
        ]).join("\n")
      else
        null

export states = [
  'unapproved'
  'checkout'
  'unpaid'
  'pending'
  'paid'
  'failed'
  'declined'
  'cancelled'
  'ended'
  'closed'
  'expired'
  'error'
  'partially_paid'
  'needs_pre_auth'
  'unauthorized'
]

export state_options = value: state, label: humanize state for state in states

export base_currency_options = value: cur, label: cur for cur in base_currencies

export state_actions = obj_with_default [],
  pending:        $w 'retry_pay'
  paid:           $w 'resend_ticket --- admin_void admin_void_without_refund cancel'
  ended:          $w 'resend_ticket --- admin_void admin_void_without_refund cancel'
  closed:         $w 'resend_ticket --- admin_void admin_void_without_refund cancel'
  error:          $w 'admin_void admin_void_without_refund mark_error_as_expired retry_pay resolve_error'
  partially_paid: $w 'admin_void admin_void_without_refund cancel'

export payment_plan_actions = obj_with_default [],
  paid:           $w 'admin_void_loan_fee'
  cancelled:      $w 'admin_void_loan_fee'
  ended:          $w 'admin_void_loan_fee'
  closed:         $w 'admin_void_loan_fee'
  error:          $w 'admin_void_loan_fee'
  partially_paid: $w 'admin_void_loan_fee'

export transition_name_overrides =
  retry_pay:                    'Retry payment'
  resolve_error:                'Resolve error'
  mark_error_as_expired:        'Mark expired'
  admin_void:                   'Void - Refund buyer'
  admin_void_without_refund:    'Void - No buyer refund & Host funds removed'
  admin_void_loan_fee:          'Refund Payment Plan Fee'
  cancel:                       'Void - Host keeps funds'

export transition_confirmations =
  admin_void_without_refund:  'This will void the ticket without refunding the buyer, Universe (not the host) will keep the money for this ticket. Are you sure you want to continue?'
  admin_void_loan_fee:        'This will refund the payment plan fee only'
  admin_void:                 (t)-> if t.provider == 'offline' then 'This is an offline purchase, are you sure you want to mark it as refunded?' else 'This will refund the buyer for this ticket. Are you sure you want to continue?'
  cancel:                     'This will void the ticket without refunding the buyer. The host will keep the money for this ticket. Are you sure you want to continue?'
